import React from 'react'

import { Picture } from '../Picture'

import styles from './DisruptorTile.module.scss'

/**
 * Tile for use in grids that represents a route.
 * @param {Object} props
 * @param {string} props.url
 * @param {string} props.imageUrl
 * @param {string} props.ctaText
 */
const DisruptorTile = ({ url, imageUrl, ctaText }) => (
    <div className={styles.container}>
        <div className={styles.wrapper}>
            <Picture className={styles.media} src={imageUrl} width={345} height={212} alt={ctaText} hasWebp />
            <a className={styles.cta} href={url}>
                {ctaText}
                <i className={'i-chevron-right ' + styles.chevron} />
            </a>
        </div>
    </div>
)

export default DisruptorTile
